<template>
  <svg
    id="Component_147_5"
    data-name="Component 147 – 5"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <circle
      id="Ellipse_229"
      data-name="Ellipse 229"
      cx="8"
      cy="8"
      r="8"
      :fill="color"
    />
    <path
      id="checkmark"
      data-name="Path 5312"
      d="M9,12l2,2,4-4"
      transform="translate(-4 -4)"
      fill="none"
      stroke="transparent"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'var(--theme-primary)',
    },
  },
};
</script>
